import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { PageNotFoundComponent } from '../../../components/page-not-found/page-not-found.component';
import { Paths } from '../../../enums/paths.enum';
import { RouteLabels } from '../../../enums/routeLabels.enum';
import { AuthGuard } from '../../../shared/auth.guard';
import { CanDeactivateGuard } from '../../../shared/can-deactivate.guard';
import { AdjustmentsAndReclassesPage } from '../adjustments-and-reclasses/adjustments-and-reclasses.page';
import { AnnualReportFinancialStatementImportPage } from '../annual-report-financial-statement-import/annualReportFinancialStatementImport.page';
import { AnnualReportAOPPage } from '../aop/aop.page';
import { AnnualReportCSFPage } from '../cash-flow-statement/cash-flow-statement.page';
import { ComplementaryReportsPage } from '../complementary-reports/complementary-reports.page';
import { AnnualReportEquityMovementSchedulePage } from '../equity-movement-schedule/equity-movemenet-schedule.page';
import { FinancialClosingProcessPage } from '../financial-closing-process/financialClosingProcess.page';
import { AnnualReportFixedAssetsSchedulePage } from '../fixed-assets-schedule/fixed-assets-schedule.page';
import { AnnualReportGeneralInformationV2Page } from '../general-information-v2/annual-report-general-information-v2.page';
import { NotesPage } from '../notes/notes.page';
import { AnnualReportPrintPage } from '../print-page/annualReportPrint.page';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.GENERAL_INFORMATION}`, pathMatch: 'full' },
            {
                path: `${Paths.GENERAL_INFORMATION}`,
                component: AnnualReportGeneralInformationV2Page,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_GENRAL_INFORMATION,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.IMPORT}`,
                component: AnnualReportFinancialStatementImportPage,
                loadChildren: () =>
                    import(
                        '../annual-report-financial-statement-import/annualReportFinancialStatementImport.module'
                    ).then((m) => m.FinancialStatementImportModule),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_IMPORT,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.FINANCIAL_CLOSING_PROCESS}`,
                component: FinancialClosingProcessPage,
                canDeactivate: [CanDeactivateGuard],
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_CLOSING_PROCESS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.CFS}`,
                component: AnnualReportCSFPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_CASH_FLOW,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.NOTES_STEP}`,
                component: NotesPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_NOTES_STEP,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.AOP}`,
                component: AnnualReportAOPPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_AOP,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.EQUITY_MOVEMENT_SCHEDULE}`,
                component: AnnualReportEquityMovementSchedulePage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_EQUITY_MOVEMENT_SCHEDULE,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.FAS}`,
                component: AnnualReportFixedAssetsSchedulePage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_FIXED_ASSETS_SCHEDULE,
                },
            },
            {
                path: `${Paths.ADJUSTMENTS_AND_RECLASSES}`,
                component: AdjustmentsAndReclassesPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_ADJUSTMENTS_AND_RECLASSES,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.COMPLEMENTARY_REPORTS}`,
                component: ComplementaryReportsPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_COMPLEMENTARY_REPORTS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.PRINT}`,
                component: AnnualReportPrintPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_FINISH_AND_PRINT,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            { path: '**', component: PageNotFoundComponent },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class FinancialStatementEditModule {}
